// extracted by mini-css-extract-plugin
export default {"section":"Si_NLn5j5m2xxMn3BNYQ","content":"XhjSzumqzO4eVvLnAQxj","header":"bkpTtOxsDxzQC7gCZgQS"};